/**
 * Persistência da config do operador (API URL + admin token) em localStorage.
 *
 * Defaults pegos de variáveis de ambiente Vite (VITE_API_URL) quando definidas,
 * senão fallback para http://localhost:8000.
 *
 * O token NUNCA tem default — operador precisa configurar antes de usar.
 */

const STORAGE_KEY = "ipwd-noc-config-v1";

const DEFAULT_API_URL =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) ||
  "http://localhost:8000";

const DEFAULTS = {
  apiUrl: DEFAULT_API_URL,
  adminToken: "",
  refreshSeconds: 10,
};

export function loadConfig() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULTS, ...parsed };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveConfig(cfg) {
  const merged = { ...loadConfig(), ...cfg };
  // Sanitize: nunca grava undefined; força string nos textos
  const safe = {
    apiUrl: String(merged.apiUrl || DEFAULTS.apiUrl).replace(/\/+$/, ""),
    adminToken: String(merged.adminToken || ""),
    refreshSeconds: clamp(Number(merged.refreshSeconds) || 10, 3, 300),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(safe));
  return safe;
}

export function clearConfig() {
  localStorage.removeItem(STORAGE_KEY);
}

function clamp(n, lo, hi) {
  return Math.max(lo, Math.min(hi, n));
}
